// extracted by mini-css-extract-plugin
module.exports = {"root":"accordion-item_root__DVuUI"};